import {Middleware} from '@reduxjs/toolkit'

import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import authMiddleware from './authMiddleware'
import errorLoggerMiddleware from './errorLoggerMiddleware'
import loggerMiddleware from './loggerMiddleware'
import orderInterruptedMiddleware from './orderInterruptedMiddleware'
import uiEventLoggerMiddleware from './uiEventLoggerMiddleware'

const Middlewares: Middleware[] = [
    authMiddleware,
    loggerMiddleware,
    orderInterruptedMiddleware,
    uiEventLoggerMiddleware,
    browserEventEmitter,
    errorLoggerMiddleware,
]
export default Middlewares
